module.exports = __webpack_public_path__ + "static/media/use07.90be513a.png";